import { get, clone } from "../../utils/object-helpers";
import TextWithSeparator from "<str-text-with-separator>";
import TextualDisplayValue from "<str-textual-display>";
import ListingTextSpan from "<str-listing-text-span>";
import ProductReview from "<str-product-review>";
import ImageSquare from "<str-image-square>";
import IconAndText from "<str-icon-text>";
import CardTitle from "<str-card-title>";
import TimerModel from "<str-timer>";
import EekTire from "<str-eek-tire>";
import Signal from "<str-signal>";
import Icon from "<str-icon>";
static const componentMapping = {
    additionalPrice: TextualDisplayValue,
    purchaseOptions: TextualDisplayValue,
    authenticityGuarantee: IconAndText,
    logisticsCost: TextualDisplayValue,
    displayPrice: TextualDisplayValue,
    displayTime: TextualDisplayValue,
    eekrating: TextualDisplayValue,
    unitPrice: TextualDisplayValue,
    discount: TextualDisplayValue,
    bidCount: TextualDisplayValue,
    quantity: TextualDisplayValue,
    productReview: ProductReview,
    seeAll: TextualDisplayValue,
    itemHotness: IconAndText,
    image: ImageSquare,
    timer: TimerModel,
    eekTire: EekTire,
    title: CardTitle,
    "__search.additionalPriceWithToolTipText": TextualDisplayValue,
    "__search.nonMskuAdditionalPrice": TextualDisplayValue,
    "__search.itemHotnessCustomizedOrder": IconAndText,
    "__search.freeReturnsNoFee": TextualDisplayValue,
    "__search.normalizedCondition": ListingTextSpan,
    "__search.displayAttributes": TextWithSeparator,
    "__search.freeXDays": TextualDisplayValue,
    "__search.eekrating": TextualDisplayValue,
    "__search.unitPrice": TextualDisplayValue,
    "__search.productReview": ProductReview,
    "__search.titleTags": ListingTextSpan,
    "__search.smeInfo": IconAndText,
    "__search.eekTire": EekTire,
    "__search.timer": TimerModel,
    __signal: Signal
}

<if(input.properties && input.properties[input.sectionName])>
    <div class=`str-item-card__${input.sectionName}`>
        <for|position, positionIdx| of=input.properties[input.sectionName]>
            $ const blockTag = position.length > 1 ? "span" : null;
            <${blockTag} class="str-item-card__property-block">
                <for|property, idx| of=position>
                    $ const propertyItem = get(input.card, property, null);
                    <if(propertyItem)>
                        $ {
                            const propertyType = get(propertyItem, "_type", null);

                            if (property === "image") {
                                propertyItem.noAltTitle = true;
                            }

                            if (property === "image" && input.card._type !== "NavigationCard") {
                                propertyItem.noScaling = true;
                            }
                        }
                        <if(property === "__search.titleTags")>
                            $ const titleTags = propertyItem;
                            <for|titleTag, idx| of=titleTags>
                                <if(titleTag === "TextualDisplayValue")>
                                    <str-textual-display
                                        key=idx
                                        class=`str-item-card__property-${property}`
                                        imageSize=input.imageSize
                                        isSmall=input.isSmall
                                        ...titleTag
                                    />
                                </if>
                                <else-if(titleTag === "ListingTextSpan")>
                                    <str-listing-text-span
                                        key=idx
                                        class=`str-item-card__property-${property}`
                                        imageSize=input.imageSize
                                        isSmall=input.isSmall
                                        ...titleTag
                                    />
                                </else-if>
                                <else-if(titleTag === "TextSpan")>
                                    <str-listing-text-span
                                        key=idx
                                        class=`str-item-card__property-${property}`
                                        imageSize=input.imageSize
                                        isSmall=input.isSmall
                                        ...titleTag
                                    />
                                </else-if>
                                <else>
                                    <${componentMapping[property]}
                                        key=idx
                                        class=`str-item-card__property-${property}`
                                        imageSize=input.imageSize
                                        isSmall=input.isSmall
                                        ...titleTag
                                    />
                                </else>
                            </for>
                        </if>
                        <else>
                            <if(propertyType === "TextualDisplayValue")>
                                <str-textual-display
                                    key=idx
                                    class=`str-item-card__property-${property}`
                                    imageSize=input.imageSize
                                    isSmall=input.isSmall
                                    ...propertyItem
                                />
                            </if>
                            <else-if(propertyType === "ListingTextSpan")>
                                <str-listing-text-span
                                    key=idx
                                    class=`str-item-card__property-${property}`
                                    imageSize=input.imageSize
                                    isSmall=input.isSmall
                                    ...propertyItem
                                />
                            </else-if>
                            <else-if(propertyType === "TextSpan")>
                                <str-listing-text-span
                                    key=idx
                                    class=`str-item-card__property-${property}`
                                    imageSize=input.imageSize
                                    isSmall=input.isSmall
                                    ...propertyItem
                                />
                            </else-if>
                            <else>
                                $ {
                                    const isQuickviewSection = input.sectionName === 'primary' || input.sectionName == 'header';
                                    const isQuickviewProp = property === 'title' || property === 'image';
                                    const useQuickview = input.card?.isQuickviewEnabled && isQuickviewSection && isQuickviewProp;
                                }
                                <if(useQuickview)>
                                    $ {
                                        const mutatedItemCard = clone(propertyItem);
                                        // Remove action property so that it's not rendered as a link.
                                        delete mutatedItemCard.action;
                                        // Remove accessibilityText to prevent it from rendering in hidden span.
                                        delete mutatedItemCard.accessibilityText;
                                        const className = property === 'image' ? 'str-item-card__link' : 'str-item-card__property-title'
                                    }
                                    <str-quickview-button ...input.card classAttr=className>
                                        <${componentMapping[property]}
                                            key=idx
                                            class=`str-item-card__property-${property}`
                                            imageSize=input.imageSize
                                            isSmall=input.isSmall
                                            ...mutatedItemCard
                                        />
                                    </str-quickview-button>
                                </if>
                                <else>
                                    <${componentMapping[property]}
                                        key=idx
                                        class=`str-item-card__property-${property}`
                                        imageSize=input.imageSize
                                        isSmall=input.isSmall
                                        target=(input.card._type === 'ITEM' && property === 'title' && '_blank')
                                        ...propertyItem
                                    />
                                </else>
                            </else>
                        </else>
                    </if>
                </for>
            </>
        </for>
    </div>
</if>
